<!--
 * @Author: chj
 * @Date: 2024-10-10 15:37:41
 * @LastEditors: chj
 * @LastEditTime: 2024-10-22 12:01:45
 * @Description: 请填写简介
-->
<template>
  <div :class="bem()">
    <h3 :class="bem('title')">联盟成员</h3>
    <div :class="bem('list')">
      <div
        :class="bem('item')"
        v-for="(partner, index) in partnerList"
        :key="index">
        <div :class="bem('item-title')">{{ partner.name }}</div>
        <swiper-container
          :class="bem('swiper')"
          :loop="true"
          :autoplay-delay="5000"
          navigation="true"
        >
          <swiper-slide :class="bem('slide')" v-for="(group, index) in partner.list" :key="index">
            <div :class="bem('slide-item')">
              <a-col :class="bem('item-col')" :span="4" v-for="(item, index) in group" :key="index">
                <img :class="bem('item-icon')" :src="item.file_url" alt="" />
              </a-col>
            </div>
          </swiper-slide>
        </swiper-container>
        
      </div>
    </div>
  </div>
</template>

<script>
import { getDicts } from '@/api/system/dict'
import { getHomeMember } from '@/api/home/member'
import {
  Row as ARow,
  Col as ACol,
} from 'ant-design-vue'
export default {
  name: 'partner',
  components: {
    ARow,
    ACol
  },
  data() {
    return {
      dictList: [
        {
          dictLabel: "理事长单位",
          dictValue: "1",
        },
        {

          dictLabel: "副理事长单位",
          dictValue: "2",
        },
        {
          dictLabel: "理事单位",
          dictValue: "3",
        },
        {
          dictLabel: "会员单位",
          dictValue: "4",
        }
      ],
      partnerList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 1000,
      }
    }
  },
  methods: {
    groupByTypeAndLabel(dictArray, fileArray, groupSize = 6) {
      const typeLabelMap = dictArray.reduce((map, dictItem) => {
        map[dictItem.dictValue] = dictItem.dictLabel;
        return map;
      }, {});

      const groupedResult = {};

      fileArray.forEach(fileItem => {
        const type = fileItem.type;
        const label = typeLabelMap[type] || "未知类型";

        if (!groupedResult[type]) {
          groupedResult[type] = { type: parseInt(type, 10), name: label, list: [] };
        }
        groupedResult[type].list.push(fileItem);
      });

      Object.keys(groupedResult).forEach(type => {
        const group = groupedResult[type];
        const paginatedList = [];

        for (let i = 0; i < group.list.length; i += groupSize) {
          paginatedList.push(group.list.slice(i, i + groupSize));
        }
        group.list = paginatedList;
      });

      // 转换为数组并返回
      return Object.values(groupedResult);
    },
    async initData() {
      try {
        const res = await getHomeMember(this.queryParams);
        if (res.code == 0) {
          const data = this.groupByTypeAndLabel(this.dictList, res.data.list)
          this.partnerList = data
          console.log('partnerList', this.partnerList)
        }
      } catch(err) {
        console.log('err', err)
      }
    },
  },
  mounted() {
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.partner {
  width: 100%;
  margin: 0 auto;
  &__title {
    height: 40px;
    margin-bottom: 80px;
    line-height: 40px;
    color: rgb(16,16,16);
    font-size: 28px;
    text-align: center;
  }
  &__list {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    @include devices(laptop) {
      padding: 0 40px;
    }
    @include devices(pad) {
      padding: 0 20px;
    }
  }
  &__item {
    width: 100%;
    flex-shrink: 0;
    margin-bottom: 30px;
    &-title {
      margin-bottom: 20px;
      font-size: 14px;
      font-weight: bold;
      color: #000;
      line-height: 25px;
      text-align: center;
    }
    &-group {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    &-col {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      height: 100%;
    }
    &-icon {
      width: 100%;
      max-height: 60px;
    }
  }
  &__swiper {
    width: 100%;
    height: 100px;
    overflow: hidden;
    --swiper-theme-color: #ff6900;
  }
  &__slide {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    &-item {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        width: auto;
        height: auto;
      }
    }
  }
  // &__item {
  //   cursor: pointer;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   width: 25%;
  //   @include devices(pad) {
  //     width: calc(100% / 3);
  //   }
  //   @include devices(phone) {
  //     width: 50%;
  //   }
  //   &-inner {
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     width: 220px;
  //     height: 120px;
  //     margin-bottom: 60px;
  //     background-color: rgba(255,255,255,1);
  //     border: 1px solid #e3e8ee;
  //     border-radius: 6px;
  //     @include devices(laptop) {
  //       width: 200px;
  //       height: 100px;
  //     }
  //     @include devices(pad) {
  //       width: 180px;
  //       height: 80px;
  //     }
  //     @include devices(phone) {
  //       width: 160px;
  //       height: 80px;
  //     }
  //     &:hover {
  //       box-shadow: 0 1px 3px 0 rgba(37, 48, 68, .12), 0 8px 16px -4px rgba(37, 48, 68, .16);
  //     }
  //     img {
  //       -webkit-user-drag: none;
  //       user-select: none;
  //       max-width: 80%;
  //       max-height: 80%;
  //     }
  //   }
  // }
}
</style>
